import { createCoreMethod } from '../../utils/createCoreMethod';
import { findNodeById } from '../../utils/findNodeById';

export const renderImage = createCoreMethod(
  'renderImage',
  async (nodeId: string, url: string, x: number, y: number) => {
    const fullNode = findNodeById(nodeId, figma.currentPage, 2);

    if (!fullNode) return null;

    try {
      const nodeName = `Heatmap - ${nodeId}`;

      const figmaImage = await figma.createImageAsync(url);
      const node = figma.createRectangle();

      const { width, height } = await figmaImage.getSizeAsync();
      node.name = nodeName;
      node.resize(width, height);

      node.x = x;
      node.y = y;
      node.fills = [
        {
          type: 'IMAGE',
          imageHash: figmaImage.hash,
          scaleMode: 'FILL',
        },
      ];
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Rendering image error', e);
    }
  }
);
